import React from 'react';
import MainLayout from '../../layout/MainLayout';
import StepSixHeader from '../../components/AssessmentsAndTests/StepSix/StepSixHeader';
import StepSixContent from '../../components/AssessmentsAndTests/StepSix/StepSixContent';
import DashboardLayout from "../../layout/DashboardLayout";


const AssessmentResultView = () => {
  const resultId = new URLSearchParams(window.location.search).get('resultId');
  const retakeUrl: any = new URLSearchParams(window.location.search).get(
    'retakeUrl'
  );
  const retake = () => {
    (window as Window).location = retakeUrl || '/';
  };
  return (
    // <MainLayout
    //   headerProgress={100}
    //   headerContent={<StepSixHeader retake={retake} />}
    // >
    //   <StepSixContent id={resultId || ''} />
    // </MainLayout>
    <DashboardLayout>
      <StepSixContent headerProgress={100} retake={retake} id={resultId || ''} />
    </DashboardLayout>
  );
};

export default AssessmentResultView;
